import Styles from './WizardLoading.module.scss';

import { IosSpinner } from '@/components/Elements/IosSpinner';
export const WizardLoading = () => {
	return (
		<div className={Styles.container}>
			<span>... Loading</span>
			<IosSpinner size="3.125rem" duration={1.2} />
		</div>
	);
};
